/*
 * tgc-pdp.js
 * One controller for every TGC block on the pdp-v2 product page.
 *
 * Reads a single JSON island (snippets/tgc-pdp-data.liquid) holding the facts
 * for every variant, works out the selected variant and quantity, and updates
 * each block in place. Every block is fully server-rendered for the variant the
 * page loads with, so if this script never runs the page is still correct; it
 * only goes stale when the shopper changes variant or quantity.
 *
 * Listens at document level, so it survives the theme replacing the product
 * form in the DOM.
 */
(function () {
  'use strict';

  var island = document.querySelector('script[data-tgc-pdp-data]');
  if (!island) return;

  var D;
  try { D = JSON.parse(island.textContent); } catch (e) { return; }
  var S = D.s || {};
  var V = D.v || {};

  /* Every option value on the product, so a spec row labelled "180 cm" can be
     recognised as belonging to an option rather than to all variants. */
  var OPTVALS = {};
  Object.keys(V).forEach(function (id) {
    (V[id].o || []).forEach(function (val) { if (val) OPTVALS[val] = true; });
  });

  /* ---------- pure helpers, no DOM ---------------------------------------- */

  function fill(tpl, map) {
    return String(tpl == null ? '' : tpl).replace(/\{(\w+)\}/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  }

  function weeksLabel(n) {
  var lo = Math.max(1, n - 1), hi = n < 2 ? 2 : n + 1;
  return fill(S.week_range, { lo: lo, hi: hi });
}

  /* The ledger: one sentence for the selected variant at the chosen quantity. */
  function ledger(v, qty) {
    if (!v.tr) return { text: S.untracked || '', state: 'none' };

    var on = Math.max(0, parseInt(v.on, 10) || 0);
    var days = v.cls === 'pallet' ? S.days_pallet : (v.cls === 'parcel' ? S.days_parcel : '');
    var wk = v.wk ? weeksLabel(v.wk) : '';

    if (on >= qty) {
      if (qty === 1) {
        return { text: days ? fill(S.in_one, { days: days }) : S.in_one_nd, state: 'ok' };
      }
      return {
        text: days ? fill(S.in_many, { qty: qty, days: days }) : fill(S.in_many_nd, { qty: qty }),
        state: 'ok'
      };
    }

    if (on === 0) {
      if (qty === 1) {
        return { text: wk ? fill(S.made_one_d, { weeks: wk }) : S.made_one_u, state: 'made' };
      }
      return {
        text: wk ? fill(S.made_many_d, { qty: qty, weeks: wk }) : fill(S.made_many_u, { qty: qty }),
        state: 'made'
      };
    }

    return {
      text: wk ? fill(S.part_d, { avail: on, qty: qty, weeks: wk })
               : fill(S.part_u, { avail: on, qty: qty }),
      state: 'made'
    };
  }

  /* People to plan for, at 25 kg a person (Dutch Arbo working threshold). */
  function peopleLine(g) {
    var tpl = g.ppl >= 4 ? S.gi_four : (g.ppl === 3 ? S.gi_three : (g.ppl === 2 ? S.gi_two : ''));
    return tpl ? fill(tpl, { kg: g.h }) : '';
  }

  /* ---------- size option: price per tile, note beside it --------------- */

  var SI = D.si || 0;   /* 1-based position of the size option, 0 if none */

  function priceForSize(cur, sizeVal) {
    var idx = SI - 1, exact = null, low = null;
    Object.keys(V).forEach(function (id) {
      var w = V[id];
      if (!w.o || w.o[idx] !== sizeVal) return;
      var same = true;
      for (var i = 0; i < w.o.length; i++) {
        if (i !== idx && w.o[i] !== cur.o[i]) { same = false; break; }
      }
      if (same) exact = w;
      if (!low || w.pn < low.pn) low = w;
    });
    return (exact || low || {}).pf || '';
  }

  /* ---------- reading the product form ------------------------------------ */

  function mainForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (!/payment-installment$/.test(forms[i].id || '')) return forms[i];
    }
    return null;
  }

  function byName(form, name) {
    var inside = form.querySelector('[name="' + name + '"]');
    if (inside) return inside;
    if (form.id) {
      var linked = document.querySelector('[name="' + name + '"][form="' + form.id + '"]');
      if (linked) return linked;
    }
    return document.querySelector('.shopify-section--main-product [name="' + name + '"]');
  }

  function currentState() {
    var form = mainForm();
    if (!form) return null;
    var idField = byName(form, 'id');
    var v = idField ? V[String(idField.value)] : null;
    if (!v) return null;
    var qField = byName(form, 'quantity');
    var qty = qField ? parseInt(qField.value, 10) : 1;
    if (!qty || qty < 1) qty = 1;
    return { v: v, qty: qty };
  }

  /* ---------- DOM writers ------------------------------------------------- */

  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function text(root, sel, value) {
    all(sel, root).forEach(function (n) { n.textContent = value == null ? '' : value; });
  }

  function row(root, key, value) {
    all('[data-tgc-row="' + key + '"]', root).forEach(function (r) {
      var has = value !== null && value !== undefined && value !== '';
      r.hidden = !has;
      var dd = r.querySelector('[data-tgc-val]');
      if (dd && has) dd.textContent = value;
    });
  }

  function line(root, key, value) {
    all('[data-tgc-line="' + key + '"]', root).forEach(function (n) {
      n.hidden = !value;
      if (value) n.textContent = value;
    });
  }

  /* A download link that shows only when the variant has the file. */
  function doc(root, sel, url) {
    all(sel, root).forEach(function (a) {
      if (url) { a.href = url; a.parentNode.hidden = false; }
      else { a.parentNode.hidden = true; }
    });
  }

  function dimRow(t) {
    var r = document.createElement('div');
    r.className = 'tgc-row';
    var dt = document.createElement('dt');
    var i = t.indexOf(':');
    if (i > -1) {
      dt.textContent = t.slice(0, i).trim();
      var dd = document.createElement('dd');
      dd.textContent = t.slice(i + 1).trim();
      r.appendChild(dt);
      r.appendChild(dd);
    } else {
      dt.className = 'tgc-row__full';
      dt.textContent = t;
      r.appendChild(dt);
    }
    return r;
  }

  /* ---------- per-block render -------------------------------------------- */

  function placeNote(picker, fs) {
    var notes = all('[data-tgc-vnote]');
    if (!notes.length) return;
    var keep = null;
    notes.forEach(function (n) { if (!picker.contains(n)) keep = n; });
    if (!keep) keep = notes[0];
    var home = picker.contains(keep) ? null : keep.closest('.product-info__block-item');
    notes.forEach(function (n) { if (n !== keep && n.parentNode) n.parentNode.removeChild(n); });
    if (fs.nextElementSibling !== keep) fs.insertAdjacentElement('afterend', keep);
    if (home && home.getAttribute('data-block-type') === 'liquid') home.style.display = 'none';
  }

  function labelSize(fs, v) {
    var holder = fs.querySelector('.variant-picker__option-info .h-stack');
    if (!holder) return;
    var cur = (v.o && v.o[SI - 1]) || '';
    var tag = holder.querySelector('.tgc-size-sel');
    if (!tag) {
      tag = document.createElement('span');
      tag.className = 'tgc-size-sel';
      holder.appendChild(tag);
    }
    if (tag.textContent !== cur) tag.textContent = cur;
  }

  function enhancePicker(v) {
    if (!SI) return;
    var picker = document.querySelector('variant-picker[context="main_product"]');
    if (!picker) return;
    var sets = picker.querySelectorAll(':scope > fieldset.variant-picker__option');
    var fs = sets[SI - 1];
    if (!fs) return;

    all('.block-swatch', fs).forEach(function (tile) {
      var nameEl = tile.querySelector('span:not(.tgc-size-price):not(.block-swatch__color)');
      var name = (nameEl ? nameEl.textContent : tile.textContent).trim();
      var tag = tile.querySelector('.tgc-size-price');
      if (!tag) {
        tag = document.createElement('span');
        tag.className = 'tgc-size-price';
        tile.appendChild(tag);
      }
      var p = priceForSize(v, name);
      if (tag.textContent !== p) tag.textContent = p;
    });

    labelSize(fs, v);
    placeNote(picker, fs);
  }

  function render() {
    var st = currentState();
    if (!st) return;
    var v = st.v, qty = st.qty;
    if (observer) observer.disconnect();

    all('[data-tgc-vnote]').forEach(function (box) {
      box.hidden = !v.sum;
      text(box, '[data-tgc-vnote-text]', v.sum);
    });

    var L = ledger(v, qty);
    all('[data-tgc-ledger]').forEach(function (b) {
      b.setAttribute('data-state', L.state);
      b.hidden = !L.text;
      text(b, '[data-tgc-ledger-text]', L.text);
    });

    var A = (S.assure || {})[v.cls || 'any'] || (S.assure || {}).any;
    if (A) {
      all('[data-tgc-assure]').forEach(function (box) {
        text(box, '[data-tgc-assure-dt]', A.dt);
        text(box, '[data-tgc-assure-dx]', A.dx);
        text(box, '[data-tgc-assure-rx]', A.rx);
      });
    }

    all('[data-tgc-dim]').forEach(function (sec) {
      var hasLines = v.dl && v.dl.length;
      sec.hidden = !(hasLines || v.sp || v.img);

      var list = sec.querySelector('[data-tgc-dim-lines]');
      if (list) {
        list.innerHTML = '';
        (v.dl || []).forEach(function (t) { list.appendChild(dimRow(t)); });
        list.hidden = !hasLines;
      }

      var sp = sec.querySelector('[data-tgc-dim-space]');
      if (sp) {
        sp.hidden = !v.sp;
        text(sp, '[data-tgc-dim-space-text]', v.sp);
      }

      var fig = sec.querySelector('[data-tgc-dim-figure]');
      var split = sec.querySelector('[data-tgc-dim-split]');
      if (fig) {
        var img = fig.querySelector('img');
        if (v.img && img) {
          img.src = v.img.u;
          if (v.img.ss) img.srcset = v.img.ss; else img.removeAttribute('srcset');
          img.width = v.img.w;
          img.height = v.img.h;
          fig.hidden = false;
        } else {
          fig.hidden = true;
        }
      }
      if (split) split.classList.toggle('tgc-split--media', !!v.img);
    });

    all('[data-tgc-getin]').forEach(function (sec) {
      var g = v.gi;
      sec.hidden = !(g && g.show);
      if (!g) return;
      row(sec, 'cartons', g.c);
      row(sec, 'largest', g.l);
      row(sec, 'heaviest', g.h ? g.h + ' kg' : '');
      row(sec, 'doorway', g.d ? g.d + ' cm' : '');
      line(sec, 'two', peopleLine(g));
      line(sec, 'turn', g.turn ? fill(S.gi_turn, { cm: g.lg }) : '');
      line(sec, 'asm', g.c >= 2 ? fill(S.gi_asm, { n: g.c }) : '');
      all('[data-tgc-asm]', sec).forEach(function (n) { n.hidden = !(g.c >= 2); });
    });

    /* 15 specification: only the rows that apply to the selected variant,
       and the documents that belong to it */
    all('[data-tgc-spec]').forEach(function (sec) {
      text(sec, '[data-tgc-spec-variant]', v.t);
      row(sec, 'variant', v.t);
      row(sec, 'weight', v.kg ? v.kg + ' kg' : '');
      row(sec, 'sku', v.sku);
      all('[data-tgc-k]', sec).forEach(function (r) {
        var k = r.getAttribute('data-tgc-k');
        r.hidden = !!OPTVALS[k] && !(v.o && v.o.indexOf(k) > -1);
      });
      doc(sec, '[data-tgc-spec-sheet]', v.sh);
      doc(sec, '[data-tgc-spec-guide]', v.ig);
    });

    enhancePicker(v);
    watch();
  }

  /* ---------- wiring ------------------------------------------------------ */

  var observer = null;
  function watch() {
    var root = document.querySelector('.shopify-section--main-product');
    if (!root || typeof MutationObserver === 'undefined') return;
    if (!observer) observer = new MutationObserver(function () { schedule(); });
    observer.observe(root, { childList: true, subtree: true });
  }

  var frame = 0;
  function schedule() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(function () {
      frame = 0;
      render();
      setTimeout(render, 160);
    });
  }

  document.addEventListener('change', schedule, true);
  document.addEventListener('input', schedule, true);
  document.addEventListener('variant:change', schedule);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('quantity-selector, .quantity-selector, button[name], [data-action]')) {
      schedule();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();
